import React, { useEffect, useState } from 'react'
import * as routeLink from "../../constants/routeLink";

import CardShopDog from "../../components/CardShopDog/index";
import ProcessBar from "../../components/ProcessBar/index";

import { useNavigate } from 'react-router-dom';
import { top } from '../../services/services';
const Index = (props) => {

  const navigate = useNavigate();
  const onclickChangePage = (path) => {
    navigate(path);
  }

  const [dataShop, setdataShop] = useState([]);

  useEffect(() => {
    getData()
  }, []);

  const getData = async () => {
    const res = await top();
    if (res?.code == 200) {
      console.log(res);
      if (res?.data) {
        setdataShop(res?.data)
      }
    }
  }

  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>


      <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2'>

        <div className='d-flex w-100 flex-column justify-content-center align-items-center'>
          <h4 className='w-100 text-white justify-content-center align-items-center fs-extra d-flex m-0 mx-2'>Top</h4>

        </div>
      </div>

      <div className='w-100 d-flex justify-content-center align-items-start flex-column p-2'>
        {dataShop && dataShop.map((value, index) => {

          return <CardShopDog key_={index} item={value} actions={() => onclickChangePage(routeLink.DAILY_REWARD)} />
        })}

      </div>

    </div>
  )
}

export default Index;
